module.exports = __webpack_public_path__ + "static/media/entity-viewer-tooltip.ac6f82b3.png";